import { render, staticRenderFns } from "./TierProgress.vue?vue&type=template&id=3fdcc3e7&scoped=true"
import script from "./TierProgress.vue?vue&type=script&lang=js"
export * from "./TierProgress.vue?vue&type=script&lang=js"
import style0 from "./TierProgress.vue?vue&type=style&index=0&id=3fdcc3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdcc3e7",
  null
  
)

export default component.exports